<template>
    <div>
        <label v-if="label" :for="id" class="block text-sm font-medium text-gray-700">{{label}}&nbsp;</label>
        <div class="w-full inline-flex ring-green-500 mt-1 border-gray-300 rounded-md overflow-hidden " style="border-width:1px; border-style:solid;">
            <div class="form-input-icon flex items-center text-gray-200" :class="iconRight? 'order-2 pr-3' : 'pl-3'" v-if="icon">
                <Icons i="search" />
            </div>
            <input :style="uppercase?`text-transform:uppercase;` : ''" :aria-placeholder="placeholder" :disabled="disabled" :max="max" :maxlength="maxlen" :placeholder="placeholder || label" :required="required" :type="type || 'text' " :name="id" :id="id" :autocomplete="id + 'nope'" class="inline-block w-full shadow-sm sm:text-sm border-0 bg-white flex-1" @input="$emit('update:modelValue',$event.target.value)" :value="modelValue" :class="classes">
        </div>
        <p v-if="showErrors && (checkError && !isValid)" class="text-sm text-red-800">{{checkError}}</p>
    </div>
</template>

<script>
import { nanoid } from 'nanoid'
import Icons from '@/components/Icons'
export default {
    components:{Icons},
    props:{
        uppercase:{
            type:Boolean,
            default:false,
        },
        disabled:{
            type:Boolean,
            default:false
        },
        maxlen:{
            type:Number,
            default:50
        },
        required:{
            type:Boolean,
            default:false
        },
        placeholder:{
            type:String,
            default:''
        },
        showErrors:{
            type:Boolean,
            default:false
        },
        id:{
            type:String,
            default:null
        },
        label:{
            type:String,
            default:'',
        },
        modelValue:{
            type:[String,Number],
            default:''
        },
        type:{
            type:String,
            default:'text'
        },
        rules:{
            type:Object,
            default:{}
        },
        check:{
            type:[Function,String],
            default:''
        },
        checkError:{
            type:String,
            default:''
        },
        max:{
            type:Number,
            default:null
        },
        icon:{
            type:String,
            default:'',
        },
        iconRight:{
            type:Boolean,
            default:true
        }
    },
    computed:{
        uid(){
            let name = this.label || this.placeholder
            name = name.trim().toLowerCase().replace(/ /g,'-')
            let id = this.id || nanoid(3)
            return `${name}-${id}`

        },
      
        isEmpty(){
            if (this.type !== 'number') return Boolean(!this.modelValue.trim())
            else return isNaN(parseFloat(this.modelValue))
        },
        classes(){
            if (this.showErrors && ((this.required && this.isEmpty) || (typeof this.check === 'function' && !this.isValid))) {
                return 'border-red border-2px'
            } else return ''
        },
        isReq(){
            return this.rules.req || this.rules.required || false
        },
        min(){
            if (rules.min) return rules.min 
            else return 0
        },
    
        hasError(){
            return this.check
        },
        showCheck(){
            return typeof this.check === 'function'
        },
        isValid(){
            if (this.check === '') return true 
            return this.check(this.modelValue)
        },
    
    }

  

}
</script>

<style scoped>
    .form-input-icon svg{
        width:20px;

    }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

</style>